import { useState } from 'react'

import type { ChatAttachment } from './attachments'
import {
  rememberAttachmentUrl,
  stableAttachmentUrl
} from './stableAttachmentUrl'
import { useStyles } from './styles'
import type { ResolveAttachmentUrl } from './useAttachmentActions'

type Props = {
  attachment: ChatAttachment
  busy: boolean
  onOpen: () => void
  resolveUrl?: ResolveAttachmentUrl
}

export const ChatAttachmentThumbnail = ({
  attachment,
  busy,
  onOpen,
  resolveUrl
}: Props) => {
  const { styles } = useStyles()
  const [refreshedUrl, setRefreshedUrl] = useState<string | null>(null)
  const [refreshAttempted, setRefreshAttempted] = useState(false)

  // The link on a message is presigned for 15 minutes; one fresh link is
  // fetched when it has expired, never a loop.
  const refreshExpiredUrl = () => {
    if (refreshAttempted || !resolveUrl) return

    setRefreshAttempted(true)
    resolveUrl(attachment)
      .then((url) => {
        rememberAttachmentUrl(attachment.id, url)
        setRefreshedUrl(url)
      })
      .catch(() => undefined)
  }

  const src = refreshedUrl ?? stableAttachmentUrl(attachment)

  return (
    <button
      type="button"
      className={styles.attachmentThumbnail}
      aria-busy={busy}
      onClick={() => {
        if (!busy) onOpen()
      }}
    >
      <img
        src={src ?? undefined}
        alt={attachment.filename}
        loading="lazy"
        onLoad={() => {
          if (src) rememberAttachmentUrl(attachment.id, src)
        }}
        onError={refreshExpiredUrl}
      />
    </button>
  )
}
